import { render, staticRenderFns } from "./OzneList.vue?vue&type=template&id=d397351a&"
import script from "./OzneList.vue?vue&type=script&lang=js&"
export * from "./OzneList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports